export default "__VITE_ASSET__B$D$R_77__"